import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../assets/images/back-left-icon.png';
const _hoisted_1 = {
  class: "nav-bar"
};
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_3 = {
  class: "center"
};
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { getTitle } from "../utils/theme";
export default {
  __name: 'v-nav-bar',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const {
      locale
    } = useI18n();
    const title = computed(() => {
      void locale.value;
      return getTitle();
    });
    const goBack = () => {
      if (route.path == "/") {
        return;
      }
      router.go(-1);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "left",
        onClick: goBack
      }, [_unref(route).path != '/' && _unref(route).path != '/login' ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(title.value), 1)]), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "right"
      }, null, -1))]);
    };
  }
};